var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "pay-dialog",
          staticStyle: { margin: "0 auto" },
          attrs: {
            title: _vm.$t("pay.title"),
            visible: _vm.isShowPay,
            width: "90%",
            top: "2vh",
            "append-to-body": "",
            "before-close": _vm.payClose
          }
        },
        [
          _c(
            "el-tabs",
            {
              attrs: { type: "card" },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: _vm.$t("pay.title"), name: "first" } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "payorder",
                      staticClass: "demo-shopform",
                      attrs: {
                        model: _vm.payorder,
                        inline: true,
                        "label-width": "200px",
                        border: ""
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("purchase.tablelist[0]"),
                            prop: "num"
                          }
                        },
                        [
                          _c("div", { staticStyle: { width: "200px" } }, [
                            _vm._v(_vm._s(_vm.payorder.num))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("financial.tablelist[0]"),
                            prop: "purclass"
                          }
                        },
                        [
                          _c("div", { staticStyle: { width: "200px" } }, [
                            _vm._v(_vm._s(_vm.payorder.purclass))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("pay.name[13]"),
                            prop: "apNum"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.payorder.apNum,
                              callback: function($$v) {
                                _vm.$set(_vm.payorder, "apNum", $$v)
                              },
                              expression: "payorder.apNum"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("purchase.tablelist[2]"),
                            prop: "fullname"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.payorder.fullname,
                              callback: function($$v) {
                                _vm.$set(_vm.payorder, "fullname", $$v)
                              },
                              expression: "payorder.fullname"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("empfile.tablename[5]"),
                            prop: "tel"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.payorder.tel,
                              callback: function($$v) {
                                _vm.$set(_vm.payorder, "tel", $$v)
                              },
                              expression: "payorder.tel"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      false
                        ? _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("purchase.tablelist[17]") }
                            },
                            [
                              _c("el-input", {
                                attrs: { type: "number", disabled: "" },
                                model: {
                                  value: _vm.payorder.VatRate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.payorder, "VatRate", $$v)
                                  },
                                  expression: "payorder.VatRate"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("pay.name[11]") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.payorder.Tax,
                              callback: function($$v) {
                                _vm.$set(_vm.payorder, "Tax", $$v)
                              },
                              expression: "payorder.Tax"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("pay.name[12]") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.payorder.totalAmount,
                              callback: function($$v) {
                                _vm.$set(_vm.payorder, "totalAmount", $$v)
                              },
                              expression: "payorder.totalAmount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("pay.name[10]"),
                            prop: "money"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled:
                                _vm.isLookb == true || _vm.payorder.isUseDetail
                            },
                            model: {
                              value: _vm.payorder.money,
                              callback: function($$v) {
                                _vm.$set(_vm.payorder, "money", $$v)
                              },
                              expression: "payorder.money"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("supplier.dialog[16]"),
                            prop: "shortEng"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.payorder.shortEng,
                              callback: function($$v) {
                                _vm.$set(_vm.payorder, "shortEng", $$v)
                              },
                              expression: "payorder.shortEng"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      false
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("purchase.tablelist[5]"),
                                prop: "paytype"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.payorder.paytype,
                                  callback: function($$v) {
                                    _vm.$set(_vm.payorder, "paytype", $$v)
                                  },
                                  expression: "payorder.paytype"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("pay.name[8]"),
                            prop: "Invoice"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.isLookb == true },
                            model: {
                              value: _vm.payorder.Invoice,
                              callback: function($$v) {
                                _vm.$set(_vm.payorder, "Invoice", $$v)
                              },
                              expression: "payorder.Invoice"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("pay.name[1]"),
                            prop: "InvoiceDate"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              format: "yyyy-MM-dd",
                              disabled: _vm.isLookb == true
                            },
                            model: {
                              value: _vm.payorder.InvoiceDate,
                              callback: function($$v) {
                                _vm.$set(_vm.payorder, "InvoiceDate", $$v)
                              },
                              expression: "payorder.InvoiceDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("invoice.Add[10]"),
                            prop: "paydt"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              format: "yyyy-MM-dd",
                              disabled: ""
                            },
                            model: {
                              value: _vm.payorder.paydt,
                              callback: function($$v) {
                                _vm.$set(_vm.payorder, "paydt", $$v)
                              },
                              expression: "payorder.paydt"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      false
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("pay.name[0]"),
                                prop: "payer"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.payorder.payer,
                                  callback: function($$v) {
                                    _vm.$set(_vm.payorder, "payer", $$v)
                                  },
                                  expression: "payorder.payer"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("pay.name[2]"),
                            prop: "payState"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.payorder.ispaystate,
                              callback: function($$v) {
                                _vm.$set(_vm.payorder, "ispaystate", $$v)
                              },
                              expression: "payorder.ispaystate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      false
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("financial.tablelist[21]"),
                                prop: "cardid"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.payorder.cardid,
                                  callback: function($$v) {
                                    _vm.$set(_vm.payorder, "cardid", $$v)
                                  },
                                  expression: "payorder.cardid"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("subscribe.labellist[2]"),
                            prop: "applydt"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.payorder.applydt,
                              callback: function($$v) {
                                _vm.$set(_vm.payorder, "applydt", $$v)
                              },
                              expression: "payorder.applydt"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.purchaseOrder !== null &&
                      _vm.purchaseOrder !== undefined
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("purchase.tablelist[4]"),
                                prop: ""
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.purchaseOrder.discount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.purchaseOrder, "discount", $$v)
                                  },
                                  expression: "purchaseOrder.discount"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("supplier.dialog[7]"),
                            prop: "address"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "575px" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.payorder.address,
                              callback: function($$v) {
                                _vm.$set(_vm.payorder, "address", $$v)
                              },
                              expression: "payorder.address"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "address",
                          attrs: {
                            label: _vm.$t("purchaseOrder.purchasetabs[1]"),
                            prop: "explain"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: _vm.isLookb == true,
                              type: "textarea",
                              autosize: { minRows: 2, maxRows: 3 }
                            },
                            model: {
                              value: _vm.payorder.explain,
                              callback: function($$v) {
                                _vm.$set(_vm.payorder, "explain", $$v)
                              },
                              expression: "payorder.explain"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "address",
                          attrs: {
                            label: _vm.$t("subscribe.labellist[4]"),
                            prop: "explain"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: _vm.isLookb == true,
                              type: "textarea",
                              autosize: { minRows: 2, maxRows: 3 }
                            },
                            model: {
                              value: _vm.purchaseOrder.explain,
                              callback: function($$v) {
                                _vm.$set(_vm.purchaseOrder, "explain", $$v)
                              },
                              expression: "purchaseOrder.explain"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("pay.isUseDetail"),
                            prop: "isUseDetail"
                          }
                        },
                        [
                          _c("el-checkbox", {
                            attrs: { disabled: _vm.isLookb == true },
                            on: { change: _vm.changeRecordDetailItem },
                            model: {
                              value: _vm.payorder.isUseDetail,
                              callback: function($$v) {
                                _vm.$set(_vm.payorder, "isUseDetail", $$v)
                              },
                              expression: "payorder.isUseDetail"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.purchaseOrder != null
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "formtable",
                              staticStyle: { width: "100%" },
                              attrs: { label: "" }
                            },
                            [
                              _c(
                                "el-table",
                                {
                                  ref: "detailTable",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "empty-text": _vm.$t("header.tableEmpty"),
                                    stripe: "",
                                    border: "",
                                    "row-key": "purchaseOrder",
                                    data: _vm.payorder.itemList
                                  },
                                  on: {
                                    "selection-change": _vm.changeItemSelection
                                  }
                                },
                                [
                                  _c(
                                    "el-table-column",
                                    {
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "header",
                                            fn: function(scope) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          type: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.exportCurrentItemList(
                                                              scope
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "GoodsList.filesout"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("select-excel", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "subscribe.button[2]"
                                                        ),
                                                        "before-upload":
                                                          _vm.importUpdateCurrentItemList
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        3717478725
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          type: "selection",
                                          width: "55",
                                          "reserve-selection": true,
                                          selectable: _vm.checkboxChecking
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "subscribe.labellist[9]"
                                          ),
                                          width: "100",
                                          prop: "Goods.num",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "pay.detailTableHeader[0]"
                                          ),
                                          width: "250",
                                          prop: "name",
                                          align: "center",
                                          "show-overflow-tooltip": ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "pay.detailTableHeader[2]"
                                          ),
                                          width: "100",
                                          prop: "baseQty",
                                          align: "center",
                                          "show-overflow-tooltip": ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "subscribe.labellist[12]"
                                          ),
                                          prop: "Goods.unit",
                                          width: "110",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "pay.detailTableHeader[3]"
                                          ),
                                          width: "150",
                                          prop: "price",
                                          align: "center",
                                          "show-overflow-tooltip": ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "pay.detailTableHeader[4]"
                                          ),
                                          width: "130",
                                          prop: "qty",
                                          align: "center"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(scope) {
                                                return [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: {
                                                      type: "number",
                                                      disabled: !_vm.payorder
                                                        .isUseDetail,
                                                      min: "0",
                                                      max: scope.row.baseQty
                                                    },
                                                    on: {
                                                      input: _vm.changeItemQty
                                                    },
                                                    model: {
                                                      value: scope.row.qty,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "qty",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.qty"
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1123700993
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "pay.detailTableHeader[5]"
                                          ),
                                          width: "120",
                                          prop: "VatRate",
                                          align: "center",
                                          "show-overflow-tooltip": ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "pay.detailTableHeader[6]"
                                          ),
                                          width: "180",
                                          prop: "Tax",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          formatter: _vm.tableFormatter
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "pay.detailTableHeader[7]"
                                          ),
                                          width: "180",
                                          prop: "totalMoney",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          formatter: _vm.tableFormatter
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "pay.detailTableHeader[8]"
                                          ),
                                          width: "180",
                                          prop: "totalAmount",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          formatter: _vm.tableFormatter
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "end"
                          }
                        },
                        [
                          _vm.isLookb == false
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.submitOrder }
                                },
                                [_vm._v(_vm._s(_vm.$t("GoodsList.submitBtn")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isnotify == true && _vm.isLookb == true
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.auditOrder }
                                },
                                [_vm._v(_vm._s(_vm.$t("audit.buttons[1]")))]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: _vm.$t("pay.title2"), name: "second" } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "empty-text": _vm.$t("header.tableEmpty"),
                        stripe: "",
                        border: "",
                        data: _vm.purchaseOrder.GoodsList,
                        "row-key": "GoodsList"
                      }
                    },
                    [
                      _c(
                        "el-table-column",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "header",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "warning" },
                                          on: { click: _vm.updateCurrentPO }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("pay.button[0]"))
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.filesOut(scope)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("GoodsList.filesout"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("subscribe.labellist[9]"),
                              width: "110",
                              prop: "Goods.num",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("subscribe.labellist[10]"),
                              width: "270",
                              prop: "Goods.name",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("subscribe.labellist[17]"),
                              width: "110",
                              prop: "BaseCount",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("subscribe.labellist[11]"),
                              width: "110",
                              prop: "count",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        type: "number",
                                        disabled: "",
                                        min: "0"
                                      },
                                      model: {
                                        value: scope.row.count,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "count", $$v)
                                        },
                                        expression: "scope.row.count"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("purchase.tablelist[24]"),
                              width: "110",
                              prop: "price",
                              align: "center",
                              formatter: _vm.tableFormatter,
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("subscribe.labellist[19]"),
                              width: "120",
                              prop: "requestReason",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("div", [
                                      _vm._v(_vm._s(scope.row.requestReason))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("subscribe.labellist[12]"),
                              width: "110",
                              prop: "Goods.unit",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("GoodsList.dialog[28]"),
                              prop: "price",
                              width: "110",
                              formatter: _vm.tableFormatter,
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("purchase.tablelist[17]"),
                              width: "110",
                              prop: "VatRate",
                              "show-overflow-tooltip": "",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-input", {
                                      staticStyle: { width: "60px !important" },
                                      attrs: {
                                        type: "number",
                                        min: "0",
                                        max: "20",
                                        disabled: _vm.isLookb == true
                                      },
                                      model: {
                                        value: scope.row.VatRate,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "VatRate", $$v)
                                        },
                                        expression: "scope.row.VatRate"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              formatter: _vm.tableFormatter,
                              label: _vm.$t("purchase.tablelist[21]"),
                              width: "110",
                              prop: "10",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("GoodsList.dialog[21]"),
                              width: "120",
                              prop: "Goods.NeedInspect",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("purchase.tablelist[19]"),
                              prop: "PQInfo",
                              width: "120",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("purchase.tablelist[20]"),
                              width: "110",
                              prop: "FromDepart",
                              "show-overflow-tooltip": ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: _vm.$t("pay.title1"), name: "third" } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "empty-text": _vm.$t("header.tableEmpty"),
                        stripe: "",
                        border: "",
                        data: _vm.detailItemList,
                        "row-key": "detailItemList"
                      }
                    },
                    [
                      _c(
                        "el-table-column",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "header",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.filesOut1(scope)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("GoodsList.filesout"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("el-table-column", {
                            key: "ItemCode",
                            attrs: {
                              label: _vm.$t("subscribe.labellist[9]"),
                              width: "100",
                              prop: "ItemCode",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            key: "ItemName",
                            attrs: {
                              label: _vm.$t("subscribe.labellist[10]"),
                              width: "100",
                              prop: "ItemName",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("subscribe.labellist[36]"),
                              width: "120",
                              prop: "LocalLanguage",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("subscribe.labellist[11]"),
                              width: "100",
                              prop: "Qty",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("subscribe.labellist[45]"),
                              width: "100",
                              prop: "UnitPrice",
                              align: "center",
                              formatter: _vm.tableFormatter,
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("subscribe.labellist[12]"),
                              width: "90",
                              prop: "Unit",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("subscribe.labellist[46]"),
                              prop: "TotalAmount",
                              formatter: _vm.tableFormatter,
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("subscribe.labellist[37]"),
                              width: "90",
                              prop: "Tax",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              formatter: _vm.tableFormatter,
                              label: _vm.$t("subscribe.labellist[38]"),
                              prop: "TotalTax",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("subscribe.labellist[39]"),
                              width: "120",
                              prop: "purchaseType",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("subscribe.labellist[34]"),
                              width: "120",
                              prop: "AccountNO",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("subscribe.labellist[33]"),
                              width: "120",
                              prop: "AccountName",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("subscribe.labellist[40]"),
                              width: "120",
                              prop: "Department",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("subscribe.labellist[41]"),
                              prop: "PONum",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("subscribe.labellist[42]"),
                              width: "130",
                              prop: "CreatePODate",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("subscribe.labellist[43]"),
                              width: "120",
                              prop: "RequestNO",
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("subscribe.labellist[44]"),
                              width: "120",
                              prop: "RequestDate",
                              "show-overflow-tooltip": ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label:
                      _vm.$t("pay.name[5]") +
                      " " +
                      _vm.$t("purchaseOrder.purchasetabs[2]"),
                    name: "four"
                  }
                },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "uploadc",
                      staticStyle: { display: "flex", width: "auto" },
                      attrs: {
                        action: _vm.uploadpurchURL,
                        data: _vm.uploadData,
                        "show-file-list": false,
                        "on-remove": _vm.purchChange,
                        "on-preview": _vm.clickFiles,
                        "on-success": _vm.purchSuccess,
                        "before-remove": _vm.fileDelete,
                        disabled: _vm.isPurchb == false
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-around",
                            height: "100%"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-start",
                                "align-items": "center",
                                "flex-direction": "column",
                                "margin-top": "20px"
                              }
                            },
                            [
                              _vm.isPurchb == true
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("GoodsList.dialog[11]"))
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "uploadTable",
                              staticStyle: {
                                width: "65%",
                                margin: "auto 0",
                                height: "100%",
                                overflow: "hidden",
                                "overflow-y": "scroll"
                              }
                            },
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "empty-text": _vm.$t("header.tableEmpty"),
                                    data: _vm.payorder.purchList,
                                    stripe: "",
                                    "show-header": false
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { prop: "filename" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-right": "10px",
                                                  "font-size": "15px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.filename)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-circle-check",
                                              staticStyle: { color: "#67c23a" }
                                            })
                                          ]
                                        }
                                      }
                                    ])
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { prop: "download" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "el-link",
                                              {
                                                staticStyle: {
                                                  "font-size": "15px"
                                                },
                                                attrs: {
                                                  type: "primary",
                                                  icon: "el-icon-download"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.clickFiles(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "GoodsList.dialog[12]"
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label:
                      _vm.$t("pay.name[6]") +
                      " " +
                      _vm.$t("purchaseOrder.purchasetabs[2]"),
                    name: "five"
                  }
                },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "uploadc",
                      staticStyle: { display: "flex", width: "auto" },
                      attrs: {
                        action: _vm.uploadfinancURL,
                        data: _vm.uploadData,
                        "show-file-list": false,
                        "on-remove": _vm.financChange,
                        "on-preview": _vm.clickFiles,
                        "on-success": _vm.financSuccess,
                        "before-remove": _vm.fileDelete,
                        disabled: _vm.isPurchb == true
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-around",
                            height: "100%"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-start",
                                "align-items": "center",
                                "flex-direction": "column",
                                "margin-top": "20px"
                              }
                            },
                            [
                              _vm.isPurchb == false
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("GoodsList.dialog[11]"))
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "uploadTable",
                              staticStyle: {
                                width: "65%",
                                margin: "auto 0",
                                height: "100%",
                                overflow: "hidden",
                                "overflow-y": "scroll"
                              }
                            },
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "empty-text": _vm.$t("header.tableEmpty"),
                                    data: _vm.payorder.financList,
                                    stripe: "",
                                    "show-header": false
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { prop: "filename" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-right": "10px",
                                                  "font-size": "15px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.filename)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-circle-check",
                                              staticStyle: { color: "#67c23a" }
                                            })
                                          ]
                                        }
                                      }
                                    ])
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { prop: "download" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "el-link",
                                              {
                                                staticStyle: {
                                                  "font-size": "15px"
                                                },
                                                attrs: {
                                                  type: "primary",
                                                  icon: "el-icon-download"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.clickFiles(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "GoodsList.dialog[12]"
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a7b3282", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a7b3282","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PurchasingManagement/AddPaymentOrder.vue
// module id = null
// module chunks = 